import React from 'react';
import './Destinations.css';

export default function Destinations() {
  const destinations = [
    {
      id: 1,
      name: 'New Delhi',
      flag: '🇮🇳',
      image: '/assets/595549239.jpeg',
    },
    {
      id: 2,
      name: 'Bangalore',
      flag: '🇮🇳',
      image: '/assets/595550098.jpeg',
    },
    {
      id: 3,
      name: 'Mumbai',
      flag: '🇮🇳',
      image: '/assets/595550306.jpeg',
    },
    {
      id: 4,
      name: 'Chennai',
      flag: '🇮🇳',
      image: '/assets/595550229.jpeg',
    },
    {
      id: 5,
      name: 'Hyderabad',
      flag: '🇮🇳',
      image: '/assets/45450075.jpeg',
    },
  ];

  return (
    <section className="block destinations-section">
      <div className="container">
        <div className="section-head">
          <h2>Trending Destinations</h2>
          <p className="sub">Most popular choices for travelers from India</p>
        </div>
        <div className="destinations-grid">
          {destinations.map((dest) => (
            <div key={dest.id} className="destination-card-large">
              <img src={dest.image} alt={dest.name} onError={(e) => (e.target.style.display = 'none')} />
              <div className="destination-overlay">
                <h3>{dest.name} <span className="flag">{dest.flag}</span></h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
